/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.23/esri/copyright.txt for details.
*/
import{isSome as r}from"../../../core/maybe.js";function e(e){return r(e)&&r(e.cubeMap)&&!e.running&&e.coverage>0}export{e as isReadyCloudsData};
